export const initialState = () => ({
  catalog: {
    academicYears: [],
    months: [],
    centers: [],
    services: [],
    specialists: [],
    documentTypes: [],
    therapyDocumentTypes: [],
    specialistsOrCompanies: [],
    statusList: [],
  },
  filter: {
    academicYear: null,
    month: null,
    service: null,
    center: null,
    specialist: null,
    specialistInfo: {
      name: '',
    },
    results: [],
    resultsData: [],
    resultsChunked: [],
    therapyDocumentType: null,
    specialistsOrCompanies: null,
    isAdminOrSpecialist: false,
  },
  paging: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
  },
  configPaginated: {
    pageSize: 15,
  },
});

export const state = initialState();
